import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.css'],
    standalone: false
})
export class ContactUsComponent implements OnInit {

  ngOnInit(): void {
    document.getElementsByTagName('mat-sidenav-content')[0]?.scrollTo(0, 0);
  }

}
